var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icon_awesome-facebook",
    "data-name": "Icon awesome-facebook",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.195,
    height: 21.012,
    viewBox: "0 0 21.195 21.012",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-facebook-2",
    "data-name": "Icon awesome-facebook",
    d: "M21.757,11.133A10.6,10.6,0,1,0,9.5,21.575V14.188H6.812V11.133H9.5V8.8a3.734,3.734,0,0,1,4-4.112,16.35,16.35,0,0,1,2.372.206V7.5H14.543a1.53,1.53,0,0,0-1.727,1.651v1.984h2.939l-.47,3.056H12.816v7.387A10.582,10.582,0,0,0,21.757,11.133Z",
    transform: "translate(-0.563 -0.563)",
    fill: "#7f93b2"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.a7772ecc1873aea31f57d8d5934881f5.svg";
export { ForwardRef as ReactComponent };